import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import TopNav from "./components/TopNav";
import Footer from "./components/Footer";

import Login from "./pages/Login";
import Activities from "./pages/Activities";
import Matrix from "./pages/Matrix";
import QsoLog from "./pages/QsoLog";
import Stats from "./pages/Stats";
import SuperAdmin from "./pages/SuperAdmin";
import Organizer from "./pages/Organizer";
import Profile from "./pages/Profile";
import PublicActivities from "./pages/PublicActivities";
import PublicMatrix from "./pages/PublicMatrix";
import LegalNotice from "./pages/LegalNotice";
import SetupPassword from "./pages/SetupPassword";
import QslTemplateEditor from "./pages/QslTemplateEditor";
import PropagationMap from "./pages/PropagationMap";
import QslSearch from "./pages/QslSearch";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
          <TopNav />
          <div style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Navigate to="/actividades" replace />} />
              <Route path="/login" element={<Login />} />

              <Route path="/actividades" element={<ProtectedRoute><Activities /></ProtectedRoute>} />
              <Route path="/actividades/:activityId/matriz" element={<ProtectedRoute><Matrix /></ProtectedRoute>} />
              <Route path="/actividades/:activityId/propagacion" element={<ProtectedRoute><PropagationMap /></ProtectedRoute>} />
              <Route path="/actividades/:activityId/log" element={<ProtectedRoute><QsoLog /></ProtectedRoute>} />
              <Route path="/actividades/:activityId/estadisticas" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
              <Route path="/superadmin" element={<ProtectedRoute><SuperAdmin /></ProtectedRoute>} />
              <Route path="/organizador" element={<ProtectedRoute><Organizer /></ProtectedRoute>} />
              <Route path="/organizador/:activityId/qsl-plantilla" element={<ProtectedRoute><QslTemplateEditor /></ProtectedRoute>} />
              <Route path="/perfil" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

              {/* Vista pública — sin ProtectedRoute, no requiere sesión */}
              <Route path="/directo" element={<PublicActivities />} />
              <Route path="/directo/:activityId" element={<PublicMatrix />} />
              <Route path="/directo/:activityId/qsl" element={<QslSearch />} />

              {/* Legal — accesible sin sesión */}
              <Route path="/aviso-legal" element={<LegalNotice />} />

              {/* Definir contraseña tras el alta — accesible sin sesión */}
              <Route path="/definir-contrasena/:token" element={<SetupPassword />} />

              <Route path="*" element={<Navigate to="/actividades" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
